// Add new enums to the bottom of the list until we switch from numeric to string enums.
// Follow up SIM: https://issues.amazon.com/issues/AtoZMobile-427
var Instant;
(function (Instant) {
    Instant[Instant["AppLaunch"] = 0] = "AppLaunch";
    Instant[Instant["UserAuthentication"] = 1] = "UserAuthentication";
    Instant[Instant["NavigationStart"] = 2] = "NavigationStart";
    Instant[Instant["ProcessStart"] = 3] = "ProcessStart";
    Instant[Instant["ProcessStartFix"] = 4] = "ProcessStartFix";
    Instant[Instant["NativeAppStart"] = 5] = "NativeAppStart";
    Instant[Instant["ReactNativeAppStart"] = 6] = "ReactNativeAppStart";
    Instant[Instant["ReactNativeAppMounted"] = 7] = "ReactNativeAppMounted";
    Instant[Instant["ReactNativeViewPresented"] = 8] = "ReactNativeViewPresented";
})(Instant || (Instant = {}));
export default Instant;
//# sourceMappingURL=Instant.js.map